// Games back, and points back: how far each team is behind the best record in
// the table, and behind the most points.
//
// THE BIG SITES' COLUMN (ESPN and Yahoo carry it on a standings table, GB):
// half the difference between the leader's wins less losses and this team's.
// A tie is half a win and half a loss, so it moves neither side of that
// difference and drops out. The leader is 0, and so is every team level with
// it. POINTS BACK is the same column for a race on points (scenario Q5): the
// most points in the table less this team's.
//
// ON THE WIRE, NOT A CLIENT'S ARITHMETIC: a second frontend reading the table
// would otherwise write this again (CLAUDE.md, the backend is a product).

/**
 * Each row with its games back of the best record and its points back of the
 * most points, or null for every row while nobody has played: a table of 0–0
 * has nobody behind anybody. A total-points table has no record, so its
 * games back stay null while its points back count.
 */
export function withGamesBack<
  R extends { wins: number; losses: number; ties: number; pointsFor: number },
>(rows: readonly R[]): (R & { gamesBack: number | null; pointsBack: number | null })[] {
  const played = rows.some((r) => r.wins + r.losses + r.ties > 0);
  const scored = played || rows.some((r) => r.pointsFor > 0);
  const best = rows.reduce((m, r) => Math.max(m, r.wins - r.losses), -Infinity);
  const most = rows.reduce((m, r) => Math.max(m, r.pointsFor), -Infinity);
  return rows.map((r) => ({
    ...r,
    gamesBack: played ? (best - (r.wins - r.losses)) / 2 : null,
    pointsBack: scored ? Math.round((most - r.pointsFor) * 1000) / 1000 : null,
  }));
}
